export default "__VITE_ASSET__143beb64__"